import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

export const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  className,
}) => {
  const pages = [];
  const showPages = 5;
  
  let startPage = Math.max(1, currentPage - Math.floor(showPages / 2));
  let endPage = Math.min(totalPages, startPage + showPages - 1);
  
  if (endPage - startPage + 1 < showPages) {
    startPage = Math.max(1, endPage - showPages + 1);
  }
  
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return (
    <div className={cn("flex items-center justify-center gap-2", className)} data-testid="pagination">
      <Button
        variant="outline"
        size="icon"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage <= 1}
        className="h-9 w-9 rounded-full"
      >
        <ChevronLeft className="w-4 h-4" />
      </Button>
      
      {startPage > 1 && (
        <>
          <Button
            variant={currentPage === 1 ? "default" : "ghost"}
            size="sm"
            onClick={() => onPageChange(1)}
            className="h-9 w-9 rounded-full"
          >
            1
          </Button>
          {startPage > 2 && (
            <span className="text-muted-foreground px-2">...</span>
          )}
        </>
      )}
      
      {pages.map((page) => (
        <Button
          key={page}
          variant={currentPage === page ? "default" : "ghost"}
          size="sm"
          onClick={() => onPageChange(page)}
          className={cn(
            "h-9 w-9 rounded-full",
            currentPage === page && "bg-primary text-primary-foreground neon-glow"
          )}
        >
          {page}
        </Button>
      ))}
      
      {endPage < totalPages && (
        <>
          {endPage < totalPages - 1 && (
            <span className="text-muted-foreground px-2">...</span>
          )}
          <Button
            variant={currentPage === totalPages ? "default" : "ghost"}
            size="sm"
            onClick={() => onPageChange(totalPages)}
            className="h-9 w-9 rounded-full"
          >
            {totalPages}
          </Button>
        </>
      )}
      
      <Button
        variant="outline"
        size="icon"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
        className="h-9 w-9 rounded-full"
      >
        <ChevronRight className="w-4 h-4" />
      </Button>
    </div>
  );
};
